import {
  Ref, toRef, UnwrapRef, useContext, watch, watchEffect,
} from '@nuxtjs/composition-api';
import { Store } from 'vuex';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

const { useState } = createNamespacedHelpers('szukaj');

import { IBloczek } from '@/components/bloczki/types/IBloczek';

import IGoogleMapState from '../../../types/mapState';
import { BloczekMarker } from '../../../types/marker/BloczekMarker';

const fetchActiveMarkerBloczekFromStore = (googleMapState: UnwrapRef<IGoogleMapState<BloczekMarker, IBloczek>>): void => {
  const { store }: { store: Store<unknown> } = useContext();

  watch(
    toRef(googleMapState, 'activeMarker'),
    (newActiveMarkerPayload) => {
      store.dispatch('szukaj/fetchBloczek', newActiveMarkerPayload);
    },
    { immediate: true },
  );

  const { activeMarkerBloczek: activeMarkerBloczekFromStore } = useState(['activeMarkerBloczek']) as unknown as {
    activeMarkerBloczek: Ref<IBloczek | undefined>;
  };

  watchEffect(() => {
    googleMapState.activeMarkerExtended = activeMarkerBloczekFromStore.value;
  });
};

export default fetchActiveMarkerBloczekFromStore;
